import { Intent } from 'enums';
import React from 'react';

import { SpiralLoading as Container } from './styles';

export interface IProps {
  /**
   * The Intent of the button (Primary, warning, success etc)
   * @default Intent.NONE
   */
  intent?: Intent;
  height?: string;
}

const SpiralLoading = ({ intent, ...props }: IProps) => {
  return <Container $intent={intent} {...props} />;
};

export default SpiralLoading;
